module.exports = __webpack_public_path__ + "img/album18_42.77f15b12.jpg";